import React, {ChangeEvent} from 'react'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import CheckboxAtom from '../../@atoms/to_forms/checkbox/checkbox.atom'
import TextfieldAtom from '../../@atoms/to_forms/textfield/textfield.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import useNotifyPrefsForm from '../../@hooks/use_notify_pref_form'
import PopupComponent from './popup.component'

const FormComponent: React.FC = function () {
  const {
    labels,
    formik,
    notifyPrefs,
    setNotifyPrefs,
    formatPhoneNumber,
    closeAll,
    open,
    closePopup,
    close,
  } = useNotifyPrefsForm()

  const {touched, values, handleSubmit, handleChange, errors, setFieldValue} =
    formik

  const handleEmailCheck = (e: ChangeEvent<HTMLInputElement>) => {
    setNotifyPrefs(prevState => ({...prevState, email: e.target.checked}))
  }

  const handlePhoneCheck = (e: ChangeEvent<HTMLInputElement>) => {
    setNotifyPrefs(prevState => ({...prevState, phone: e.target.checked}))
  }

  const handlePhoneBlur = () => {
    const formatted = formatPhoneNumber()
    setFieldValue('phone', formatted)
  }

  return (
    <form onSubmit={handleSubmit}>
      <BoxAtom className="form-field-wrapper">
        <BoxAtom className="checkbox-wrapper">
          <CheckboxAtom
            disabled={notifyPrefs.emailPrefs}
            checked={notifyPrefs.email}
            onChange={handleEmailCheck}
          />
        </BoxAtom>
        <BoxAtom className="email-input-field-wrapper input-wrapper">
          <TextfieldAtom
            label={labels.notificationModal.emailInputName}
            value={values.email}
            name="email"
            variant="outlined"
            type="email"
            onChange={handleChange}
            error={touched.email && !!errors.email}
            placeholder={labels.notificationModal.emailInputName}
          />
          <TypographyAtom ahd_type="step" ap_color="error">
            {touched.email && !!errors.email ? errors.email : ''}
          </TypographyAtom>
        </BoxAtom>
      </BoxAtom>
      <BoxAtom className="form-field-wrapper">
        <BoxAtom className="checkbox-wrapper">
          <CheckboxAtom
            disabled={notifyPrefs.phonePrefs}
            checked={notifyPrefs.phone}
            onChange={handlePhoneCheck}
          />
        </BoxAtom>
        <BoxAtom className="phone-input-field-wrapper input-wrapper">
          <BoxAtom className="cc-input-field-wrapper">
            <TextfieldAtom
              label={labels.notificationModal.ccInputName}
              value={values.cc}
              name="cc"
              variant="outlined"
              type="text"
              error={touched.cc && !!errors.cc}
              onChange={handleChange}
              onBlur={handlePhoneBlur}
              placeholder={labels.notificationModal.ccInputName}
            />
          </BoxAtom>
          <BoxAtom className="number-input-field-wrapper">
            <TextfieldAtom
              label={labels.notificationModal.phoneInputName}
              value={values.phone}
              name="phone"
              variant="outlined"
              type="text"
              error={touched.phone && !!errors.phone}
              onChange={handleChange}
              onBlur={handlePhoneBlur}
              placeholder={labels.notificationModal.phoneInputName}
            />
            <TypographyAtom ahd_type="step" ap_color="error">
              {(touched.phone && !!errors.phone) || (touched.cc && !!errors.cc)
                ? errors.cc || errors.phone
                : ''}
            </TypographyAtom>
          </BoxAtom>
        </BoxAtom>
      </BoxAtom>
      <BoxAtom className="button-wrapper">
        <ButtonAtom ap_type="secondary" fullWidth type="button" onClick={close}>
          {labels.notificationModal.buttonCancel}
        </ButtonAtom>
        <ButtonAtom ap_type="primary" fullWidth type="submit">
          {labels.notificationModal.buttonFormSubmit}
        </ButtonAtom>
      </BoxAtom>
      <PopupComponent
        open={open}
        okButton={closePopup}
        cancelButton={closeAll}
      />
    </form>
  )
}

export default FormComponent
